/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500,
} from "../../types/individualPaymentEditorsController/PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1IndividualpaymentFinancialPeopleFinancialpersonid } from "../../clients/individualPaymentEditorsController/putApiV1IndividualpaymentFinancialPeopleFinancialpersonid.ts";

export const putApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationKey =
  () =>
    [
      { url: "/api/v1/individualpayment/financial-people/:financialPersonId" },
    ] as const;

export type PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationKey =
  ReturnType<
    typeof putApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationKey
  >;

export function putApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    putApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationKey();
  return mutationOptions<
    PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500
    >,
    {
      financialPersonId: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams["financialPersonId"];
      data?: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ financialPersonId, data }) => {
      return putApiV1IndividualpaymentFinancialPeopleFinancialpersonid(
        financialPersonId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Atualiza o plano com recálculo de parcelas quando muda valor/nº de parcelas/pontualidade/bolsa ou descontos, ajuste do dia de vencimento nas parcelas em aberto, aproveitamento de inscrição (quita matrícula e move p/ ApprovalPending) e fluxos de bolsa (geração forçada e desconto de bolsa). Migrado do legado IndividualPayment/FinancialPersonEdit POST. **(Requer Authorization para autenticação)**
 * @summary Atualiza o plano financeiro individual (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId}
 */
export function usePutApiV1IndividualpaymentFinancialPeopleFinancialpersonid<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse,
      ResponseErrorConfig<
        | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400
        | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401
        | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500
      >,
      {
        financialPersonId: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams["financialPersonId"];
        data?: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationKey();

  const baseOptions =
    putApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationOptions(
      config,
    ) as UseMutationOptions<
      PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse,
      ResponseErrorConfig<
        | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400
        | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401
        | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500
      >,
      {
        financialPersonId: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams["financialPersonId"];
        data?: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500
    >,
    {
      financialPersonId: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams["financialPersonId"];
      data?: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401
      | PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500
    >,
    {
      financialPersonId: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams["financialPersonId"];
      data?: PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest;
    },
    TContext
  >;
}
